// Traductions Postinity — Phase A : toasts, confirmations et textes restants de LivingCandle.
const fr = {
  tt_step_validated: "Étape validée ✅ — passage à l'étape suivante",
  tt_send_audio_fail: "Envoi audio impossible",
  tt_send_video_fail: "Envoi vidéo impossible",
  tt_error: "Erreur",
  tt_save_retry: "Enregistrement impossible — réessayez",
  tt_send_file_fail: "Envoi du fichier impossible",
  tt_pay_fail: "Paiement impossible",
  tt_send_music_fail: "Envoi de la musique impossible",
  tt_send_fail: "Envoi impossible",
  tt_cer_activated: "Cérémonie activée — déposée au coffre-fort numérique 🔒",
  tt_cer_deactivated: "Cérémonie désactivée",
  tt_max_photos: "Maximum {{n}} photos.",
  tt_file_too_big50: "« {{name}} » dépasse 50 Mo",
  tt_link_sent: "Lien envoyé à {{email}}",
  tt_garants_activated: "Garants activés — {{n}} e-mail(s) envoyé(s) 🕊️",
  del_confirm: "Voulez-vous vraiment supprimer {{what}} ?\n\n⚠️ Cette action est définitive.",
  del_item: "cet élément",
  del_photo: "cette photo",
  del_file: "ce fichier",
  del_music: "cette musique",
  del_video: "cette vidéo",
  del_recipient: "ce destinataire",
  del_msg_confirm: "Supprimer le message pour {{who}} ?",
  deact_confirm2: "Confirmez-vous la désactivation ? (2ᵉ confirmation)",
  auth_title: "Je prépare ma cérémonie",
  auth_sub: "Pour accéder à votre espace Postinity, connectez-vous ou créez votre compte gratuitement. Vous reviendrez directement sur cette page.",
  auth_register: "Créer mon compte",
  auth_login: "Se connecter",
  gp_team: "L'équipe Bougie Du Cœur",
  title_move_left: "Déplacer à gauche",
  title_move_right: "Déplacer à droite",
  title_download: "Télécharger",
};
const en = {
  tt_step_validated: "Step validated ✅ — moving to the next step",
  tt_send_audio_fail: "Audio upload failed",
  tt_send_video_fail: "Video upload failed",
  tt_error: "Error",
  tt_save_retry: "Could not save — please try again",
  tt_send_file_fail: "File upload failed",
  tt_pay_fail: "Payment failed",
  tt_send_music_fail: "Music upload failed",
  tt_send_fail: "Sending failed",
  tt_cer_activated: "Ceremony activated — stored in your digital vault 🔒",
  tt_cer_deactivated: "Ceremony deactivated",
  tt_max_photos: "Maximum {{n}} photos.",
  tt_file_too_big50: "\"{{name}}\" exceeds 50 MB",
  tt_link_sent: "Link sent to {{email}}",
  tt_garants_activated: "Guardians activated — {{n}} email(s) sent 🕊️",
  del_confirm: "Do you really want to delete {{what}}?\n\n⚠️ This action is permanent.",
  del_item: "this item",
  del_photo: "this photo",
  del_file: "this file",
  del_music: "this music",
  del_video: "this video",
  del_recipient: "this recipient",
  del_msg_confirm: "Delete the message for {{who}}?",
  deact_confirm2: "Do you confirm the deactivation? (2nd confirmation)",
  auth_title: "I'm preparing my ceremony",
  auth_sub: "To access your Postinity space, sign in or create your free account. You'll come right back to this page.",
  auth_register: "Create my account",
  auth_login: "Sign in",
  gp_team: "The Bougie Du Cœur team",
  title_move_left: "Move left",
  title_move_right: "Move right",
  title_download: "Download",
};
const es = {
  tt_step_validated: "Paso validado ✅ — pasando al siguiente paso",
  tt_send_audio_fail: "No se pudo enviar el audio",
  tt_send_video_fail: "No se pudo enviar el video",
  tt_error: "Error",
  tt_save_retry: "No se pudo guardar — inténtalo de nuevo",
  tt_send_file_fail: "No se pudo enviar el archivo",
  tt_pay_fail: "No se pudo procesar el pago",
  tt_send_music_fail: "No se pudo enviar la música",
  tt_send_fail: "No se pudo enviar",
  tt_cer_activated: "Ceremonia activada — guardada en tu caja fuerte digital 🔒",
  tt_cer_deactivated: "Ceremonia desactivada",
  tt_max_photos: "Máximo {{n}} fotos.",
  tt_file_too_big50: "«{{name}}» supera los 50 MB",
  tt_link_sent: "Enlace enviado a {{email}}",
  tt_garants_activated: "Garantes activados — {{n}} correo(s) enviado(s) 🕊️",
  del_confirm: "¿Seguro que quieres eliminar {{what}}?\n\n⚠️ Esta acción es definitiva.",
  del_item: "este elemento",
  del_photo: "esta foto",
  del_file: "este archivo",
  del_music: "esta música",
  del_video: "este video",
  del_recipient: "este destinatario",
  del_msg_confirm: "¿Eliminar el mensaje para {{who}}?",
  deact_confirm2: "¿Confirmas la desactivación? (2ª confirmación)",
  auth_title: "Preparo mi ceremonia",
  auth_sub: "Para acceder a tu espacio Postinity, inicia sesión o crea tu cuenta gratis. Volverás directamente a esta página.",
  auth_register: "Crear mi cuenta",
  auth_login: "Iniciar sesión",
  gp_team: "El equipo de Bougie Du Cœur",
  title_move_left: "Mover a la izquierda",
  title_move_right: "Mover a la derecha",
  title_download: "Descargar",
};
const de = {
  tt_step_validated: "Schritt bestätigt ✅ — weiter zum nächsten Schritt",
  tt_send_audio_fail: "Audio-Upload fehlgeschlagen",
  tt_send_video_fail: "Video-Upload fehlgeschlagen",
  tt_error: "Fehler",
  tt_save_retry: "Speichern fehlgeschlagen — bitte erneut versuchen",
  tt_send_file_fail: "Datei-Upload fehlgeschlagen",
  tt_pay_fail: "Zahlung fehlgeschlagen",
  tt_send_music_fail: "Musik-Upload fehlgeschlagen",
  tt_send_fail: "Senden fehlgeschlagen",
  tt_cer_activated: "Zeremonie aktiviert — in deinem digitalen Tresor gespeichert 🔒",
  tt_cer_deactivated: "Zeremonie deaktiviert",
  tt_max_photos: "Maximal {{n}} Fotos.",
  tt_file_too_big50: "„{{name}}“ überschreitet 50 MB",
  tt_link_sent: "Link an {{email}} gesendet",
  tt_garants_activated: "Bürgen aktiviert — {{n}} E-Mail(s) gesendet 🕊️",
  del_confirm: "Möchten Sie {{what}} wirklich löschen?\n\n⚠️ Diese Aktion ist endgültig.",
  del_item: "dieses Element",
  del_photo: "dieses Foto",
  del_file: "diese Datei",
  del_music: "diese Musik",
  del_video: "dieses Video",
  del_recipient: "diesen Empfänger",
  del_msg_confirm: "Nachricht für {{who}} löschen?",
  deact_confirm2: "Bestätigen Sie die Deaktivierung? (2. Bestätigung)",
  auth_title: "Ich bereite meine Zeremonie vor",
  auth_sub: "Um auf deinen Postinity-Bereich zuzugreifen, melde dich an oder erstelle dein kostenloses Konto. Du kehrst direkt zu dieser Seite zurück.",
  auth_register: "Konto erstellen",
  auth_login: "Anmelden",
  gp_team: "Das Bougie-Du-Cœur-Team",
  title_move_left: "Nach links verschieben",
  title_move_right: "Nach rechts verschieben",
  title_download: "Herunterladen",
};
const it = {
  tt_step_validated: "Passaggio convalidato ✅ — si passa al successivo",
  tt_send_audio_fail: "Invio audio non riuscito",
  tt_send_video_fail: "Invio video non riuscito",
  tt_error: "Errore",
  tt_save_retry: "Impossibile salvare — riprova",
  tt_send_file_fail: "Invio del file non riuscito",
  tt_pay_fail: "Pagamento non riuscito",
  tt_send_music_fail: "Invio della musica non riuscito",
  tt_send_fail: "Invio non riuscito",
  tt_cer_activated: "Cerimonia attivata — depositata nella tua cassaforte digitale 🔒",
  tt_cer_deactivated: "Cerimonia disattivata",
  tt_max_photos: "Massimo {{n}} foto.",
  tt_file_too_big50: "«{{name}}» supera i 50 MB",
  tt_link_sent: "Link inviato a {{email}}",
  tt_garants_activated: "Garanti attivati — {{n}} email inviate 🕊️",
  del_confirm: "Vuoi davvero eliminare {{what}}?\n\n⚠️ Questa azione è definitiva.",
  del_item: "questo elemento",
  del_photo: "questa foto",
  del_file: "questo file",
  del_music: "questa musica",
  del_video: "questo video",
  del_recipient: "questo destinatario",
  del_msg_confirm: "Eliminare il messaggio per {{who}}?",
  deact_confirm2: "Confermi la disattivazione? (2ª conferma)",
  auth_title: "Preparo la mia cerimonia",
  auth_sub: "Per accedere al tuo spazio Postinity, accedi o crea il tuo account gratuito. Tornerai direttamente a questa pagina.",
  auth_register: "Crea il mio account",
  auth_login: "Accedi",
  gp_team: "Il team di Bougie Du Cœur",
  title_move_left: "Sposta a sinistra",
  title_move_right: "Sposta a destra",
  title_download: "Scarica",
};
const pl = {
  tt_step_validated: "Krok zatwierdzony ✅ — przejście do następnego",
  tt_send_audio_fail: "Nie udało się wysłać audio",
  tt_send_video_fail: "Nie udało się wysłać wideo",
  tt_error: "Błąd",
  tt_save_retry: "Nie udało się zapisać — spróbuj ponownie",
  tt_send_file_fail: "Nie udało się wysłać pliku",
  tt_pay_fail: "Płatność nie powiodła się",
  tt_send_music_fail: "Nie udało się wysłać muzyki",
  tt_send_fail: "Nie udało się wysłać",
  tt_cer_activated: "Ceremonia aktywowana — zapisana w cyfrowym sejfie 🔒",
  tt_cer_deactivated: "Ceremonia dezaktywowana",
  tt_max_photos: "Maksymalnie {{n}} zdjęć.",
  tt_file_too_big50: "„{{name}}” przekracza 50 MB",
  tt_link_sent: "Link wysłany do {{email}}",
  tt_garants_activated: "Poręczyciele aktywowani — wysłano {{n}} e-mail(i) 🕊️",
  del_confirm: "Czy na pewno chcesz usunąć {{what}}?\n\n⚠️ Ta akcja jest nieodwracalna.",
  del_item: "ten element",
  del_photo: "to zdjęcie",
  del_file: "ten plik",
  del_music: "tę muzykę",
  del_video: "to wideo",
  del_recipient: "tego odbiorcę",
  del_msg_confirm: "Usunąć wiadomość dla {{who}}?",
  deact_confirm2: "Czy potwierdzasz dezaktywację? (2. potwierdzenie)",
  auth_title: "Przygotowuję swoją ceremonię",
  auth_sub: "Aby uzyskać dostęp do przestrzeni Postinity, zaloguj się lub załóż darmowe konto. Wrócisz bezpośrednio na tę stronę.",
  auth_register: "Załóż konto",
  auth_login: "Zaloguj się",
  gp_team: "Zespół Bougie Du Cœur",
  title_move_left: "Przesuń w lewo",
  title_move_right: "Przesuń w prawo",
  title_download: "Pobierz",
};
const fil = {
  tt_step_validated: "Na-validate ang hakbang ✅ — lumilipat sa susunod",
  tt_send_audio_fail: "Nabigo ang pag-upload ng audio",
  tt_send_video_fail: "Nabigo ang pag-upload ng video",
  tt_error: "Error",
  tt_save_retry: "Hindi ma-save — subukan muli",
  tt_send_file_fail: "Nabigo ang pag-upload ng file",
  tt_pay_fail: "Nabigo ang pagbabayad",
  tt_send_music_fail: "Nabigo ang pag-upload ng musika",
  tt_send_fail: "Nabigo ang pagpapadala",
  tt_cer_activated: "Na-activate ang seremonya — nakaimbak sa iyong digital vault 🔒",
  tt_cer_deactivated: "Na-deactivate ang seremonya",
  tt_max_photos: "Maximum na {{n}} larawan.",
  tt_file_too_big50: "Ang \"{{name}}\" ay lumampas sa 50 MB",
  tt_link_sent: "Naipadala ang link kay {{email}}",
  tt_garants_activated: "Na-activate ang mga garante — {{n}} email ang naipadala 🕊️",
  del_confirm: "Gusto mo bang burahin ang {{what}}?\n\n⚠️ Permanente ang aksyong ito.",
  del_item: "item na ito",
  del_photo: "larawang ito",
  del_file: "file na ito",
  del_music: "musikang ito",
  del_video: "video na ito",
  del_recipient: "tatanggap na ito",
  del_msg_confirm: "Burahin ang mensahe para kay {{who}}?",
  deact_confirm2: "Kinukumpirma mo ba ang pag-deactivate? (ika-2 kumpirmasyon)",
  auth_title: "Inihahanda ko ang aking seremonya",
  auth_sub: "Para ma-access ang iyong Postinity space, mag-sign in o gumawa ng libreng account. Babalik ka agad sa pahinang ito.",
  auth_register: "Gumawa ng account",
  auth_login: "Mag-sign in",
  gp_team: "Ang koponan ng Bougie Du Cœur",
  title_move_left: "Ilipat pakaliwa",
  title_move_right: "Ilipat pakanan",
  title_download: "I-download",
};
const ru = {
  tt_step_validated: "Шаг подтверждён ✅ — переход к следующему",
  tt_send_audio_fail: "Не удалось загрузить аудио",
  tt_send_video_fail: "Не удалось загрузить видео",
  tt_error: "Ошибка",
  tt_save_retry: "Не удалось сохранить — попробуйте снова",
  tt_send_file_fail: "Не удалось загрузить файл",
  tt_pay_fail: "Оплата не прошла",
  tt_send_music_fail: "Не удалось загрузить музыку",
  tt_send_fail: "Не удалось отправить",
  tt_cer_activated: "Церемония активирована — сохранена в цифровом сейфе 🔒",
  tt_cer_deactivated: "Церемония деактивирована",
  tt_max_photos: "Максимум {{n}} фото.",
  tt_file_too_big50: "«{{name}}» превышает 50 МБ",
  tt_link_sent: "Ссылка отправлена на {{email}}",
  tt_garants_activated: "Поручители активированы — отправлено писем: {{n}} 🕊️",
  del_confirm: "Вы действительно хотите удалить {{what}}?\n\n⚠️ Это действие необратимо.",
  del_item: "этот элемент",
  del_photo: "это фото",
  del_file: "этот файл",
  del_music: "эту музыку",
  del_video: "это видео",
  del_recipient: "этого получателя",
  del_msg_confirm: "Удалить сообщение для {{who}}?",
  deact_confirm2: "Подтверждаете деактивацию? (2-е подтверждение)",
  auth_title: "Я готовлю свою церемонию",
  auth_sub: "Чтобы войти в пространство Postinity, войдите или создайте бесплатный аккаунт. Вы вернётесь прямо на эту страницу.",
  auth_register: "Создать аккаунт",
  auth_login: "Войти",
  gp_team: "Команда Bougie Du Cœur",
  title_move_left: "Переместить влево",
  title_move_right: "Переместить вправо",
  title_download: "Скачать",
};
const el = {
  tt_step_validated: "Το βήμα επικυρώθηκε ✅ — μετάβαση στο επόμενο",
  tt_send_audio_fail: "Αποτυχία αποστολής ήχου",
  tt_send_video_fail: "Αποτυχία αποστολής βίντεο",
  tt_error: "Σφάλμα",
  tt_save_retry: "Αποτυχία αποθήκευσης — δοκιμάστε ξανά",
  tt_send_file_fail: "Αποτυχία αποστολής αρχείου",
  tt_pay_fail: "Η πληρωμή απέτυχε",
  tt_send_music_fail: "Αποτυχία αποστολής μουσικής",
  tt_send_fail: "Αποτυχία αποστολής",
  tt_cer_activated: "Η τελετή ενεργοποιήθηκε — αποθηκεύτηκε στο ψηφιακό σας θησαυροφυλάκιο 🔒",
  tt_cer_deactivated: "Η τελετή απενεργοποιήθηκε",
  tt_max_photos: "Έως {{n}} φωτογραφίες.",
  tt_file_too_big50: "Το «{{name}}» υπερβαίνει τα 50 MB",
  tt_link_sent: "Ο σύνδεσμος στάλθηκε στο {{email}}",
  tt_garants_activated: "Οι εγγυητές ενεργοποιήθηκαν — στάλθηκαν {{n}} email 🕊️",
  del_confirm: "Θέλετε πραγματικά να διαγράψετε {{what}};\n\n⚠️ Αυτή η ενέργεια είναι οριστική.",
  del_item: "αυτό το στοιχείο",
  del_photo: "αυτή τη φωτογραφία",
  del_file: "αυτό το αρχείο",
  del_music: "αυτή τη μουσική",
  del_video: "αυτό το βίντεο",
  del_recipient: "αυτόν τον παραλήπτη",
  del_msg_confirm: "Διαγραφή του μηνύματος για {{who}};",
  deact_confirm2: "Επιβεβαιώνετε την απενεργοποίηση; (2η επιβεβαίωση)",
  auth_title: "Προετοιμάζω την τελετή μου",
  auth_sub: "Για πρόσβαση στον χώρο σας Postinity, συνδεθείτε ή δημιουργήστε δωρεάν λογαριασμό. Θα επιστρέψετε αμέσως σε αυτή τη σελίδα.",
  auth_register: "Δημιουργία λογαριασμού",
  auth_login: "Σύνδεση",
  gp_team: "Η ομάδα Bougie Du Cœur",
  title_move_left: "Μετακίνηση αριστερά",
  title_move_right: "Μετακίνηση δεξιά",
  title_download: "Λήψη",
};
const hi = {
  tt_step_validated: "चरण मान्य ✅ — अगले चरण पर जा रहे हैं",
  tt_send_audio_fail: "ऑडियो अपलोड विफल",
  tt_send_video_fail: "वीडियो अपलोड विफल",
  tt_error: "त्रुटि",
  tt_save_retry: "सहेजना विफल — पुनः प्रयास करें",
  tt_send_file_fail: "फ़ाइल अपलोड विफल",
  tt_pay_fail: "भुगतान विफल",
  tt_send_music_fail: "संगीत अपलोड विफल",
  tt_send_fail: "भेजना विफल",
  tt_cer_activated: "समारोह सक्रिय — आपकी डिजिटल तिजोरी में सुरक्षित 🔒",
  tt_cer_deactivated: "समारोह निष्क्रिय",
  tt_max_photos: "अधिकतम {{n}} फ़ोटो।",
  tt_file_too_big50: "\"{{name}}\" 50 MB से अधिक है",
  tt_link_sent: "लिंक {{email}} को भेजा गया",
  tt_garants_activated: "गारंटर सक्रिय — {{n}} ईमेल भेजे गए 🕊️",
  del_confirm: "क्या आप वाकई {{what}} हटाना चाहते हैं?\n\n⚠️ यह क्रिया स्थायी है।",
  del_item: "यह आइटम",
  del_photo: "यह फ़ोटो",
  del_file: "यह फ़ाइल",
  del_music: "यह संगीत",
  del_video: "यह वीडियो",
  del_recipient: "यह प्राप्तकर्ता",
  del_msg_confirm: "{{who}} के लिए संदेश हटाएँ?",
  deact_confirm2: "क्या आप निष्क्रियकरण की पुष्टि करते हैं? (दूसरी पुष्टि)",
  auth_title: "मैं अपना समारोह तैयार कर रहा/रही हूँ",
  auth_sub: "अपने Postinity स्थान तक पहुँचने के लिए, साइन इन करें या मुफ़्त खाता बनाएँ। आप सीधे इसी पृष्ठ पर लौट आएँगे।",
  auth_register: "मेरा खाता बनाएँ",
  auth_login: "साइन इन करें",
  gp_team: "Bougie Du Cœur टीम",
  title_move_left: "बाएँ ले जाएँ",
  title_move_right: "दाएँ ले जाएँ",
  title_download: "डाउनलोड",
};
const ja = {
  tt_step_validated: "ステップを確定しました ✅ — 次のステップへ",
  tt_send_audio_fail: "音声のアップロードに失敗しました",
  tt_send_video_fail: "動画のアップロードに失敗しました",
  tt_error: "エラー",
  tt_save_retry: "保存できませんでした — もう一度お試しください",
  tt_send_file_fail: "ファイルのアップロードに失敗しました",
  tt_pay_fail: "支払いに失敗しました",
  tt_send_music_fail: "音楽のアップロードに失敗しました",
  tt_send_fail: "送信に失敗しました",
  tt_cer_activated: "式典を有効化しました — デジタル金庫に保管されました 🔒",
  tt_cer_deactivated: "式典を無効化しました",
  tt_max_photos: "写真は最大 {{n}} 枚まで。",
  tt_file_too_big50: "「{{name}}」は 50 MB を超えています",
  tt_link_sent: "{{email}} にリンクを送信しました",
  tt_garants_activated: "保証人を有効化しました — {{n}} 件のメールを送信 🕊️",
  del_confirm: "{{what}}を本当に削除しますか？\n\n⚠️ この操作は元に戻せません。",
  del_item: "この項目",
  del_photo: "この写真",
  del_file: "このファイル",
  del_music: "この音楽",
  del_video: "この動画",
  del_recipient: "この受取人",
  del_msg_confirm: "{{who}} 宛てのメッセージを削除しますか？",
  deact_confirm2: "無効化を確認しますか？（2回目の確認）",
  auth_title: "自分の式典を準備します",
  auth_sub: "Postinity スペースにアクセスするには、ログインするか無料アカウントを作成してください。すぐにこのページに戻ります。",
  auth_register: "アカウントを作成",
  auth_login: "ログイン",
  gp_team: "Bougie Du Cœur チーム",
  title_move_left: "左へ移動",
  title_move_right: "右へ移動",
  title_download: "ダウンロード",
};
const zh = {
  tt_step_validated: "步骤已确认 ✅ — 进入下一步",
  tt_send_audio_fail: "音频上传失败",
  tt_send_video_fail: "视频上传失败",
  tt_error: "错误",
  tt_save_retry: "保存失败 — 请重试",
  tt_send_file_fail: "文件上传失败",
  tt_pay_fail: "支付失败",
  tt_send_music_fail: "音乐上传失败",
  tt_send_fail: "发送失败",
  tt_cer_activated: "仪式已激活 — 已存入您的数字保险库 🔒",
  tt_cer_deactivated: "仪式已停用",
  tt_max_photos: "最多 {{n}} 张照片。",
  tt_file_too_big50: "“{{name}}” 超过 50 MB",
  tt_link_sent: "链接已发送至 {{email}}",
  tt_garants_activated: "担保人已激活 — 已发送 {{n}} 封邮件 🕊️",
  del_confirm: "确定要删除{{what}}吗？\n\n⚠️ 此操作不可撤销。",
  del_item: "该项目",
  del_photo: "这张照片",
  del_file: "此文件",
  del_music: "这段音乐",
  del_video: "此视频",
  del_recipient: "该收件人",
  del_msg_confirm: "删除给 {{who}} 的留言吗？",
  deact_confirm2: "确认停用吗？（第二次确认）",
  auth_title: "我在准备我的仪式",
  auth_sub: "要访问您的 Postinity 空间，请登录或免费创建账户。您将直接返回此页面。",
  auth_register: "创建账户",
  auth_login: "登录",
  gp_team: "Bougie Du Cœur 团队",
  title_move_left: "向左移动",
  title_move_right: "向右移动",
  title_download: "下载",
};
export const postinity8 = { fr, en, es, de, it, pl, fil, ru, el, hi, ja, zh };
